import { Button } from '@alfa-bank/site-button-v2';
import { Br } from '@alfa-bank/site-br';
import { Strong } from '@alfa-bank/site-deprecated-strong';
import { Grid } from '@alfa-bank/site-grid-universal';
import { Link } from '@alfa-bank/site-link';
import { Text } from '@alfa-bank/site-text-v2';
import { ArrowPopover as Tooltip } from '@alfa-bank/site-popover/arrow-popover';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import type { IBenefitsDepsDefaultDesktop, TBenefitsDefaultDesktop } from '../models';
import { renderBenefit } from '../utils/render-benefit/default';
import { subtitleText } from '../utils/subtitles-text/default';
import { subtitleWithTooltip } from '../utils/subtitles-tooltip';
import { ComponentDesktop as Component } from '../layouts/default';
import styles from '../styles/default/desktop.css';

export const BenefitsDesktop = createWidget<IBenefitsDepsDefaultDesktop, TBenefitsDefaultDesktop>({
    renderBenefit,
    subtitleText,
    subtitleWithTooltip,
    Button,
    Grid,
    Link,
    styles,
    Text,
    Tooltip,
    Br,
    Strong,
    sendEvent,
})(Component);
